import React, { useState, useEffect } from "react";
import { Header } from "./../../components/public/Header";
import { Footer } from "./../../components/public/Footer";
import { useLocation, useNavigate } from "react-router-dom";
import { getRequest } from "../../helper/api";
import Loader from "./../../components/Loader";
import {
  getItemFromLocalStorage,
  setItemInLocalStorage,
} from "../../helper/helper";
import { LazyLoadComponent } from "react-lazy-load-image-component";
import PublicImages from "../../constants/public/images";
import { Image } from "react-bootstrap";

const Layout = ({ children, showHeader = true, showFooter = true }) => {
  const navigate = useNavigate();
  const route = useLocation();
  const [PageLoader, setPageLoader] = useState(true);
  const [startUpPopupSettings, setStartUpPopupSettings] = useState(null);
  const [siteSettings, setSiteSettings] = useState(null);
  const [languageSettings, setLanguageSettings] = useState(null);
  const [logo, setLogo] = useState(null);
  const [user, setUser] = useState(null);

  const initializeSite = async () => {
    try {
      if (
        getItemFromLocalStorage("SITE_SETTINGS") &&
        getItemFromLocalStorage("REFERRAL_SETTINGS") &&
        getItemFromLocalStorage("LANGUAGE_SETTINGS") &&
        getItemFromLocalStorage("SITE_LOGO") &&
        getItemFromLocalStorage("POPUP_SETTINGS")
      ) {
        setSiteSettings(JSON.parse(getItemFromLocalStorage("SITE_SETTINGS")));
        setLogo(getItemFromLocalStorage("SITE_LOGO"));
        setUser(JSON.parse(getItemFromLocalStorage("USER")));
        setLanguageSettings(
          JSON.parse(getItemFromLocalStorage("LANGUAGE_SETTINGS"))
        );
        setStartUpPopupSettings(
          JSON.parse(getItemFromLocalStorage("POPUP_SETTINGS"))
        );
      } else {
        const response = await getRequest("/api/secure/site/site-settings");
        if (
          response?.result?.status === 200 ||
          response?.result?.status === 201
        ) {
          const {
            settings,
            siteLogo,
            referralSettings,
            languageSettings,
            startUpPopupSettings,
          } = response?.result?.data?.siteSettings[0];
          setSiteSettings(settings);
          setStartUpPopupSettings(startUpPopupSettings);
          setLanguageSettings(languageSettings);
          setLogo(siteLogo);
          setItemInLocalStorage("SITE_SETTINGS", JSON.stringify(settings));
          setItemInLocalStorage(
            "REFERRAL_SETTINGS",
            JSON.stringify(referralSettings)
          );
          setItemInLocalStorage(
            "LANGUAGE_SETTINGS",
            JSON.stringify(languageSettings)
          );
          setItemInLocalStorage(
            "POPUP_SETTINGS",
            JSON.stringify(startUpPopupSettings)
          );
          setItemInLocalStorage("SITE_LOGO", siteLogo);
        }
      }
    } catch (error) {
      console.log("Get Settigns APi error", error.message);
    } finally {
      setTimeout(() => {
        setPageLoader(false);
      }, 1000);
    }
  };

  useEffect(() => {
    initializeSite();
    const role = getItemFromLocalStorage("ROLE");
    const token = getItemFromLocalStorage("TOKEN");

    if (role && token) {
      setUser(JSON.parse(getItemFromLocalStorage("USER")));
    } else {
      const uploadRoutesRegex = /^\/[^/]+\/upload/;
      const publishedRouteRegex = /^\/[^/]+\/published/;
      const underModerationRouteRegex =
        /^\/[^/]+\/[^/]+\/under-moderation\/[^/]+/;

      if (
        route.pathname === "/account" ||
        uploadRoutesRegex.test(route.pathname) ||
        publishedRouteRegex.test(route.pathname) ||
        underModerationRouteRegex.test(route.pathname)
      ) {
        navigate("/login");
      }
    }

    // Ensure no event listeners are preventing copy or paste.
    // We are not explicitly adding or removing any 'copy' or 'paste' event listeners
    // that would call event.preventDefault().
  }, [navigate, route.pathname]);

  const childProps = {
    settings: siteSettings,
    languagesettings: languageSettings,
    logo,
    user,
    startUpPopupSettings,
    // No props related to enabling/disabling copy-paste are needed here
    // as we are relying on the default browser behavior.
  };

  const childrenWithProps = React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, childProps);
    }
    return child;
  });

  return (
    <>
      {PageLoader && !siteSettings && !logo && !languageSettings ? (
        <Loader loading={PageLoader} />
      ) : (
        <>
          {showHeader && (
            <Header
              settings={siteSettings}
              languagesettings={languageSettings}
              startUpPopupSettings={startUpPopupSettings}
              logo={logo}
              user={user}
            />
          )}
          <main id="main">
            <LazyLoadComponent>{childrenWithProps}</LazyLoadComponent>

            <div className="whatsAppCover">
              <a href="https://wa.link/45n5v1">
                <Image
                  fluid
                  src={PublicImages.WhatsAppIcon_3}
                  height={100}
                  width={100}
                  alt=""
                />
                <span>Tell Us</span>
              </a>
            </div>
          </main>
          {showFooter && (
            <Footer
              settings={siteSettings}
              languagesettings={languageSettings}
              startUpPopupSettings={startUpPopupSettings}
              logo={logo}
              user={user}
            />
          )}
        </>
      )}
    </>
  );
};

export default Layout;